module.exports = __webpack_public_path__ + "img/result-type-wrapper.edbbe5ea.png";